import { Comment } from '../types'

export const getMinimalValidComment = (): Comment => ({
  id: 'validId',
  authorId: 'authorId',
  timestamp: Date.now(),
  text: 'text'
})
